export default __webpack_public_path__ + "static/media/Step-up.b6fbcf39.png";